import React from "react";

export function Name() {
  return <p className="name">PAUL ANDERSON</p>;
}
